import { inject } from '@angular/core';
import { GroupsFacade } from '@tekman/onmat/store/group';
import { map } from 'rxjs/operators';
import { ProgramEnum } from '@tekman/onmat/models';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { appRoutes } from '@tekman/onmat/constants';

export const isOnmatGroup = (): Observable<boolean> => {
  const groupsFacade = inject(GroupsFacade);
  const router = inject(Router);

  return groupsFacade.getSelectedGroup().pipe(
    map(group => {
      if (group.programId === ProgramEnum.ONMAT) {
        return true;
      } else {
        router.navigate([appRoutes.itineraries, group.id]);
        return false;
      }
    })
  );
};
